<nav class="main-nav">
  <div class="nav-container flex justify-between">
    <div class="logo py-4">
      <a href="/home">
        <img id="logo-simcaq" src="assets/simcaqv2.svg" alt="SIMCAQ">
      </a>
    </div>

    <!-- Desktop Navigation -->
    <div class="nav-links flex gap-8 items-center">
      <a
        routerLink="/home"
        (click)="aoMudarRota('/home')"
        [ngClass]="{
          'active-border': routerUrl === '/home',
          'text-red-500': routerUrl === '/home',
          'text-charcoal-800': routerUrl !== '/home'
        }"
        class="flex items-center px-1 py-1"
      >
        <span class="text-body-xlg text-extrabold">home</span>
      </a>

      <!-- Consulta Dropdown Trigger -->
      <button
        (click)="alternarDropdownConsultas()"
        [ngClass]="{
          'active-border': dropdownConsultasAberto || isConsultaAtiva(),
          'text-red-500': dropdownConsultasAberto || isConsultaAtiva(),
          'text-charcoal-800': !dropdownConsultasAberto && !isConsultaAtiva()
        }"
        class="nav-dropdown-trigger flex items-center gap-1 px-1 py-1"
      >
        <span class="text-body-xlg text-extrabold">consulta</span>
        <img
          src="assets/icons/down.svg"
          alt="dropdown"
          class="dropdown-arrow"
          [ngClass]="{'dropdown-arrow-open': dropdownConsultasAberto, 'red-arrow': dropdownConsultasAberto || isConsultaAtiva()}"
          width="12"
          height="12"
        >
      </button>

      <!-- Padrão de Qualidade Dropdown Trigger -->
      <button
        (click)="alternarDropdownQualidade()"
        [ngClass]="{
          'active-border': dropdownQualidadeAberto || isPadraoQualidadeAtivo(),
          'text-red-500': dropdownQualidadeAberto || isPadraoQualidadeAtivo(),
          'text-charcoal-800': !dropdownQualidadeAberto && !isPadraoQualidadeAtivo()
        }"
        class="nav-dropdown-trigger flex items-center gap-1 px-1 py-1"
      >
        <span class="text-body-xlg text-extrabold">padrão de qualidade</span>
        <img
          src="assets/icons/down.svg"
          alt="dropdown"
          class="dropdown-arrow"
          [ngClass]="{'dropdown-arrow-open': dropdownQualidadeAberto, 'red-arrow': dropdownQualidadeAberto || isPadraoQualidadeAtivo()}"
          width="12"
          height="12"
        >
      </button>

      <!-- Metodologia -->
      <a
        [attr.href]="metodologiaDocumentUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="flex items-center px-1 py-1 text-charcoal-800"
      >
        <span class="text-body-xlg text-extrabold">metodologia</span>
      </a>

      <a
        routerLink="/sobre"
        (click)="aoMudarRota('/sobre')"
        [ngClass]="{
          'active-border': routerUrl === '/sobre',
          'text-red-500': routerUrl === '/sobre',
          'text-charcoal-800': routerUrl !== '/sobre'
        }"
        class="flex items-center px-1 py-1"
      >
        <span class="text-body-xlg text-extrabold">sobre</span>
      </a>
      <a
        routerLink="/equipe"
        (click)="aoMudarRota('/equipe')"
        [ngClass]="{
          'active-border': routerUrl === '/equipe',
          'text-red-500': routerUrl === '/equipe',
          'text-charcoal-800': routerUrl !== '/equipe'
        }"
        class="flex items-center px-1 py-1"
      >
        <span class="text-body-xlg text-extrabold">equipe</span>
      </a>
      <a
        routerLink="/contato"
        (click)="aoMudarRota('/contato')"
        [ngClass]="{
          'active-border': routerUrl === '/contato',
          'text-red-500': routerUrl === '/contato',
          'text-charcoal-800': routerUrl !== '/contato'
        }"
        class="flex items-center px-1 py-1"
      >
        <span class="text-body-xlg text-extrabold">contato</span>
      </a>
    </div>

    <!-- Mobile Hamburger -->
    <div (click)="alternarMenuMobile()" class="nav-links-mobile items-center">
      <img src="assets/icons/bars.svg" alt="menu-icon" width="32" height="32">
    </div>
  </div>

  <!-- Desktop Consultas Dropdown -->
  <div class="dropdown-container">
    <div
      *ngIf="dropdownConsultasAberto"
      class="dropdown-panel xl2-shadow"
    >
      <div class="dropdown-content">
        <div class="dropdown-title-section">
          <h2 class="text-heading-lg text-extrabold text-charcoal-800 m-0">Consultas</h2>
          <p class="text-heading-md text-regular text-charcoal-800 m-0">
            Opções de consulta e simulação nas esferas nacional, estadual e municipal
          </p>
        </div>

        <div class="dropdown-items-grid">
          <a routerLink="/planejamento-orcamentario-apresentacao" (click)="aoMudarRota('/planejamento-orcamentario-apresentacao')" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/icons/R1_Icone.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Orçamento para garantia de um padrão de qualidade</span>
          </a>
          <a routerLink="/financiamento-atual-necessario" (click)="aoMudarRota('/financiamento-atual-necessario')" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/icons/R2_Icone.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Financiamento atual e necessário por ente federativo</span>
          </a>
          <a routerLink="/custo-por-escola-apresentacao" (click)="aoMudarRota('/custo-por-escola-apresentacao')" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/icons/R3_Icone.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Custo das condições de qualidade por escola</span>
          </a>
          <a routerLink="/caq-apresentacao" (click)="aoMudarRota('/caq-apresentacao')" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/icons/R4_Icone.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Custo Aluno Qualidade por etapa/modalidade</span>
          </a>
          <a *ngIf="featureFlagService.funcionalidadeHabilitada('885-tela-apresentacao-relatorio-receitas-despesas')"
             routerLink="/relatorio-receitas-despesas-apresentacao" (click)="aoMudarRota('/relatorio-receitas-despesas-apresentacao')" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/icons/R5_Icone.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Receitas e Despesas da educação básica</span>
          </a>
        </div>
      </div>
    </div>

    <!-- Desktop Padrão de Qualidade Dropdown -->
    <div
      *ngIf="dropdownQualidadeAberto"
      class="dropdown-panel xl2-shadow"
    >
      <div class="dropdown-content">
        <div class="dropdown-title-section">
          <h2 class="text-heading-lg text-extrabold text-charcoal-800 m-0">Padrão de qualidade</h2>
          <p class="text-heading-md text-regular text-charcoal-800 m-0">
            Dimensões, justificativas e parâmetros para o cálculo do CAQ.
          </p>
        </div>

        <div class="dropdown-items-grid">
          <a [attr.href]="pqrDocumentUrl" target="_blank" rel="noopener noreferrer" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/ilustrations/dimensoes_justificativas.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Dimensões e justificativas</span>
          </a>
          <a routerLink="/pqr" (click)="aoMudarRota('/pqr')" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/ilustrations/parametros_calculo_caq.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Parâmetros para cálculo do CAQ</span>
          </a>
          <a routerLink="/qualidade" (click)="aoMudarRota('/qualidade')" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/ilustrations/concepcao_educacao.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Concepção de educação de qualidade</span>
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile Menu - OVERLAY -->
  <div class="mobile-menu" *ngIf="menuMobileAberto">
    <div class="mobile-nav-links">

      <div class="mobile-menu-header">
        <a href="/home" class="logo">
          <img id="logo-simcaq-mobile" src="assets/simcaqv2.svg" alt="SIMCAQ">
        </a>
        <div (click)="alternarMenuMobile()" class="mobile-close-btn">
          <img src="assets/icons/bars.svg" alt="fechar menu" width="32" height="32">
        </div>
      </div>

      <a
        routerLink="/home"
        (click)="aoMudarRota('/home')"
        [ngClass]="{
          'text-red-500': routerUrl === '/home',
          'text-charcoal-800': routerUrl !== '/home'
        }"
        class="mobile-nav-item"
      >
        <span class="text-body-xlg text-extrabold">home</span>
      </a>

      <!-- Mobile Consultas -->
      <button
        (click)="alternarDropdownConsultasMobile()"
        [ngClass]="{
          'text-red-500': dropdownConsultasMobileAberto || isConsultaAtiva(),
          'text-charcoal-800': !dropdownConsultasMobileAberto && !isConsultaAtiva()
        }"
        class="mobile-nav-item mobile-dropdown-trigger"
      >
        <span class="text-body-xlg text-extrabold">consultas</span>
        <img
          src="assets/icons/down.svg"
          alt="dropdown"
          class="dropdown-arrow"
          [ngClass]="{'dropdown-arrow-open': dropdownConsultasMobileAberto, 'red-arrow': dropdownConsultasMobileAberto || isConsultaAtiva()}"
        >
      </button>

      <div *ngIf="dropdownConsultasMobileAberto" class="mobile-dropdown-content">
        <div class="mobile-dropdown-header">
          <h2 class="text-heading-lg text-extrabold text-charcoal-800 m-0">Consultas</h2>
          <p class="text-heading-md text-regular text-charcoal-800 m-0">
            Opções de consulta e simulação nas esferas nacional, estadual e municipal
          </p>
        </div>

        <div class="mobile-dropdown-items">
          <a routerLink="/planejamento-orcamentario-apresentacao" (click)="aoMudarRota('/planejamento-orcamentario-apresentacao')" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/icons/R1_Icone.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Orçamento para garantia de um padrão de qualidade</span>
          </a>
          <a routerLink="/financiamento-atual-necessario" (click)="aoMudarRota('/financiamento-atual-necessario')" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/icons/R2_Icone.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Financiamento atual e necessário por ente federativo</span>
          </a>
          <a routerLink="/custo-por-escola-apresentacao" (click)="aoMudarRota('/custo-por-escola-apresentacao')" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/icons/R3_Icone.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Custo das condições de qualidade por escola</span>
          </a>
          <a routerLink="/caq-apresentacao" (click)="aoMudarRota('/caq-apresentacao')" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/icons/R4_Icone.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Custo Aluno Qualidade por etapa/modalidade</span>
          </a>
          <a *ngIf="featureFlagService.funcionalidadeHabilitada('885-tela-apresentacao-relatorio-receitas-despesas')"
             routerLink="/relatorio-receitas-despesas-apresentacao" (click)="aoMudarRota('/relatorio-receitas-despesas-apresentacao')" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/icons/R5_Icone.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Receitas e Despesas da educação básica</span>
          </a>
        </div>
      </div>

      <!-- Mobile Padrão de Qualidade -->
      <button
        (click)="alternarDropdownQualidadeMobile()"
        [ngClass]="{
          'text-red-500': dropdownQualidadeMobileAberto || isPadraoQualidadeAtivo(),
          'text-charcoal-800': !dropdownQualidadeMobileAberto && !isPadraoQualidadeAtivo()
        }"
        class="mobile-nav-item mobile-dropdown-trigger"
      >
        <span class="text-body-xlg text-extrabold">padrão de qualidade</span>
        <img
          src="assets/icons/down.svg"
          alt="dropdown"
          class="dropdown-arrow"
          [ngClass]="{'dropdown-arrow-open': dropdownQualidadeMobileAberto, 'red-arrow': dropdownQualidadeMobileAberto || isPadraoQualidadeAtivo()}"
        >
      </button>

      <div *ngIf="dropdownQualidadeMobileAberto" class="mobile-dropdown-content">
        <div class="mobile-dropdown-header">
          <h2 class="text-heading-lg text-extrabold text-charcoal-800 m-0">Padrão de qualidade</h2>
          <p class="text-heading-md text-regular text-charcoal-800 m-0">
            Dimensões, justificativas e parâmetros para o cálculo do CAQ.
          </p>
        </div>

        <div class="mobile-dropdown-items">
          <a [attr.href]="pqrDocumentUrl" target="_blank" rel="noopener noreferrer" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/ilustrations/dimensoes_justificativas.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Dimensões e justificativas</span>
          </a>
          <a routerLink="/pqr" (click)="aoMudarRota('/pqr')" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/ilustrations/parametros_calculo_caq.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Parâmetros para cálculo do CAQ</span>
          </a>
          <a routerLink="/qualidade" (click)="aoMudarRota('/qualidade')" class="dropdown-item">
            <div class="dropdown-item-icon">
              <img src="assets/ilustrations/concepcao_educacao.svg" alt="" width="48" height="48">
            </div>
            <span class="text-body-xlg text-regular text-charcoal-800">Concepção de educação de qualidade</span>
          </a>
        </div>
      </div>

      <!-- Metodologia -->
      <a
        [attr.href]="metodologiaDocumentUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="mobile-nav-item text-charcoal-800"
      >
        <span class="text-body-xlg text-extrabold">metodologia</span>
      </a>

      <a
        routerLink="/sobre"
        (click)="aoMudarRota('/sobre')"
        [ngClass]="{
          'text-red-500': routerUrl === '/sobre',
          'text-charcoal-800': routerUrl !== '/sobre'
        }"
        class="mobile-nav-item"
      >
        <span class="text-body-xlg text-extrabold">sobre</span>
      </a>
      <a
        routerLink="/equipe"
        (click)="aoMudarRota('/equipe')"
        [ngClass]="{
          'text-red-500': routerUrl === '/equipe',
          'text-charcoal-800': routerUrl !== '/equipe'
        }"
        class="mobile-nav-item"
      >
        <span class="text-body-xlg text-extrabold">equipe</span>
      </a>
      <a
        routerLink="/contato"
        (click)="aoMudarRota('/contato')"
        [ngClass]="{
          'text-red-500': routerUrl === '/contato',
          'text-charcoal-800': routerUrl !== '/contato'
        }"
        class="mobile-nav-item"
      >
        <span class="text-body-xlg text-extrabold">contato</span>
      </a>
    </div>
  </div>
</nav>
